import React, { useState, useMemo } from 'react';
import { Modal, Select, Space, Typography, Row, Col, Button } from 'antd';
import { DownloadOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function ModalDescargarDocumentos({
  visible,
  onClose,
  ordenPago,
  onDescargarOP,
  onDescargarDocumento,
  onDescargarCSF,
  onDescargarCaratula,
  onDescargarDocumentoConcesionados,
}) {
  const documentosDisponibles = useMemo(() => {
    if (!ordenPago) return [];

    const docs = [];
    const estatus = ordenPago.estatusOrdenPagoID || 0;

    if (ordenPago.constanciaSituacionUri || ordenPago.constanciaSituacionUri_Azure) {
      docs.push({ value: 'CSF', label: 'CSF' });
    }

    if (ordenPago.caratulaEdoCtaUri || ordenPago.caratulaEdoCtaUri_Azure) {
      docs.push({ value: 'Caratula', label: 'Carátula' });
    }

    if (estatus >= 3) {
      docs.push({ value: 'OP', label: 'OP' });
    }

    docs.push({ value: 'PDF', label: 'Factura PDF' });
    docs.push({ value: 'XML', label: 'XML' });
    docs.push({ value: 'Validacion', label: 'Validación' });

    if (ordenPago.pagoUri) {
      docs.push({ value: 'ComprobantePago', label: 'Comprobante de Pago' });
    }

    if (ordenPago.tipoOP === 3 && ordenPago.autorizacionClienteUri) {
      docs.push({ value: 'Concesionado', label: 'Concesionado' });
    }

    return docs;
  }, [ordenPago]);

  const valoresDefault = useMemo(() => {
    const defaults = [];
    return defaults;
  }, []);

  const [documentosSeleccionados, setDocumentosSeleccionados] = useState(valoresDefault);
  const [loading, setLoading] = useState(false);

  const handleSelectAll = () => {
    const allValues = documentosDisponibles.map((doc) => doc.value);
    setDocumentosSeleccionados(allValues);
  };

  const handleClearAll = () => {
    setDocumentosSeleccionados([]);
  };

  const descargarDocumento = (tipo) => {
    switch (tipo) {
      case 'CSF':
        onDescargarCSF();
        break;
      case 'Caratula':
        onDescargarCaratula();
        break;
      case 'OP':
        onDescargarOP();
        break;
      case 'PDF':
        onDescargarDocumento(0);
        break;
      case 'XML':
        onDescargarDocumento(3);
        break;
      case 'Validacion':
        onDescargarDocumento(4);
        break;
      case 'ComprobantePago':
        onDescargarDocumento(1);
        break;
      case 'Concesionado':
        onDescargarDocumentoConcesionados();
        break;
      default:
        break;
    }
  };

  const handleDescargar = async () => {
    if (documentosSeleccionados.length === 0) return;

    setLoading(true);

    try {
      documentosSeleccionados.forEach((tipo) => descargarDocumento(tipo));

      await new Promise(resolve => setTimeout(resolve, 500));
    } finally {
      setLoading(false);
    }
  };

  const handleCancelar = () => {
    setDocumentosSeleccionados(valoresDefault);
    onClose();
  };

  return (
    <Modal
      title="Descargar documentos"
      open={visible}
      onCancel={handleCancelar}
      footer={null}
      width={700}
      className="pagos-v2-modal"
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <div>
          <Text type="secondary">
            Selecciona los documentos que deseas descargar:
          </Text>
        </div>

        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%' }}
          placeholder="Selecciona uno o mas documentos a descargar"
          value={documentosSeleccionados}
          onChange={setDocumentosSeleccionados}
          options={documentosDisponibles}
          size="large"
        />

        <div>
          <Text type="secondary">
            {documentosSeleccionados.length} documento(s) seleccionado(s)
          </Text>
        </div>

        <Row gutter={10}>
          <Col span={12}>
            <Button
              block
              onClick={
                documentosSeleccionados.length === documentosDisponibles.length
                  ? handleClearAll
                  : handleSelectAll
              }
              size="large"
              icon={
                documentosSeleccionados.length === documentosDisponibles.length
                  ? <CloseOutlined />
                  : <CheckOutlined />
              }
              disabled={loading}
            >
              {documentosSeleccionados.length === documentosDisponibles.length
                ? 'Deseleccionar todos'
                : 'Seleccionar todos'}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              block
              type="primary"
              onClick={handleDescargar}
              disabled={documentosSeleccionados.length === 0}
              loading={loading}
              size="large"
              icon={!loading && <DownloadOutlined />}
            >
              {loading ? 'Descargando...' : 'Descargar seleccionados'}
            </Button>
          </Col>
        </Row>
      </Space>
    </Modal>
  );
}